import React, { Component } from 'react';
import ScrollableAnchor from 'react-scrollable-anchor'
import Header from './components/header/';
import HeroSection from './components/herosection';
import BeaHero from './components/beahero';
import SmallActions from './components/smallactions';
import WhyItMatters from './components/whyitmatters';
import Footer from './components/footer/';
import { configureAnchors } from 'react-scrollable-anchor'

configureAnchors({offset: -122, scrollDuration: 200})

const Buffer = (props) => {
  return <div className={props.name + '-buffer'}></div>;
};

class App extends Component {
  render() {
    return (
      <div>
        <Buffer name="header" />
        <Header />
        <HeroSection />
        <ScrollableAnchor id={'be-a-hero'}>
          <BeaHero />
        </ScrollableAnchor>
        <ScrollableAnchor id={'small-actions'}>
          <SmallActions />
        </ScrollableAnchor>
        <ScrollableAnchor id={'why-it-matters'}>
          <WhyItMatters />
        </ScrollableAnchor>
        <ScrollableAnchor id={'get-support'}>
          <Footer />
        </ScrollableAnchor>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js